<template>
  <button
    @click="nextStep"
    class="emat-btn emat-btn-next"
    :class="{ 'emat-btn-disabled': disabled }"
  >
    {{ $t('ButtonNext.next_step') }}
  </button>
</template>

<script>
export default {
  name: 'ButtonNext',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    nextStep() {
      this.$emit('nextStep');
      this.scrollTop();
    },

    scrollTop() {
      const body = document.body; // Safari
      const html = document.documentElement; // chrome

      body.scrollTop = 0;
      html.scrollTop = 0;
    },
  },
};
</script>
